export default __webpack_public_path__ + "static/media/in.b1c1fd89.svg";